import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { not, isNil, isEmpty } from 'ramda';

var allPresent = function allPresent(params) {
  return Object.values(params).every(function (value) {
    return not(isNil(value)) && not(isEmpty(value));
  });
};
/**
 * @description
 * The most important function in this package.
 * It provides a unified interface for the creation of "Fetchers"
 * See README for more.
 * @param toKey a function which transforms the parameters of the operation into a cache key
 * @param toFetcherFn a function which returns a `fetcherFn` (see zeit/swr for a definition)
 * @param config optional config that will get mixed into the tuple
 */


export var toFetcher = function toFetcher(toKey, toFetcherFn, config) {
  return function (req) {
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var c = arguments.length > 2 ? arguments[2] : undefined;

    var mergedConfig = _objectSpread(_objectSpread({}, config), c);

    if (allPresent(req)) {
      return [toKey(req, opt), toFetcherFn(req, opt), mergedConfig];
    } else {
      // returning a falsy value for the key will cause `swr` to defer execution
      return [null, toFetcherFn(req, opt), mergedConfig];
    }
  };
};